var exports = {
  "uL": "PopoutTitlebar.module__titlebar___Q3Jsbn",
  "pY": "PopoutTitlebar.module__titlebarMac___Q3Jsbn",
  "DD": "PopoutTitlebar.module__title___Q3Jsbn",
  "o1": "PopoutTitlebar.module__actions___Q3Jsbn",
  "bR": "PopoutTitlebar.module__actionButtonActive___Q3Jsbn",
};

module.exports = exports;
